// Copyright 2020 Prescryptive Health, Inc.

import { useContext } from 'react';
import { IProviderContext, ProviderContext } from './provider.context';

export const useProviderContext = (): IProviderContext =>
  useContext<IProviderContext>(ProviderContext);
